var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20C9.485 20 5 15.515 5 10C5 4.485 9.485 0 15 0C20.515 0 25 4.485 25 10C25 15.515 20.515 20 15 20ZM16.6667 37.575C16.6667 34.755 17.765 32.1033 19.7583 30.11L23.7183 26.15C21.2583 24.3833 18.2533 23.3317 15 23.3317C6.73 23.3333 0 30.0633 0 38.3333C0 39.2533 0.746667 40 1.66667 40H16.6667V37.575Z",
    fill: "#17468C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3437 39.9753L22.3461 37.1997C22.3461 37.1997 22.3461 37.1997 22.3461 37.1997C22.3489 33.846 25.0685 31.1287 28.4222 31.1287H33.0831V27.6912H28.4222C23.1711 27.6912 18.913 31.9458 18.9086 37.1968L18.9062 39.9725L22.3437 39.9753Z",
    fill: "#17468C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7272 36.532L36.8142 29.4923L29.7272 22.4526L27.3047 24.8914L31.9365 29.4923L27.3047 34.0932L29.7272 36.532Z",
    fill: "#17468C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferInactive);
export default __webpack_public_path__ + "static/media/refer-inactive.fcc962f744c27896dffdaa36a5d77c5a.svg";
export { ForwardRef as ReactComponent };